"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREGNANCY_FIELDS = void 0;
var entities_1 = require("@common/entities");
var constants_1 = require("../../constants");
exports.PREGNANCY_FIELDS = [
    {
        label: 'Pregnancy',
        type: entities_1.FieldType.YesNo,
        sequence: 1,
        name: 'anticipated_addition_pregnancy',
        customType: entities_1.FieldType.YesNo,
        required: true,
        enabled: true,
        options: constants_1.YES_NO_OPTIONS,
    },
    {
        label: '',
        type: entities_1.FieldType.Number,
        sequence: 2,
        name: 'anticipated_addition_pregnancy_val',
        customType: entities_1.FieldType.Number,
        required: true,
        enabled: true,
        isDependent: true,
    },
];
